<template>
  <div class="main-block">
    <div class="lists">
      <list-item
        v-for="(list, i) in FOOTER_MENU"
        :key="i"
        :list="list"
      />
    </div>

    <div class="logo container">
      <a href="/">
        <f-sprite-icon :icon-link="$options.icons.IconLogo.id" />
      </a>
      <span>Интернет-магазин яркой<br>и доступной одежды для всей семьи</span>
    </div>

    <div class="contacts container">
      <div class="title">
        Контакты
      </div>
      <span>8 800 770 01 01</span>
      Мы принимаем звонки c 7:00 до 22:00 (мск).<br>
      Звонок по России бесплатный.
      <span>helpme@fundayshop.com</span>
    </div>

    <social-networks class="socials container" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Icons */
import IconLogo from '@/assets/images/logo.multi.svg';

/* Components */
import SocialNetworks from '@/components/common/social-networks/social-networks';
import ListItem from './list-item';

export default {
  name: 'main-block',

  components: {
    SocialNetworks,
    ListItem,
  },

  icons: {
    IconLogo,
  },

  computed: {
    ...mapGetters({
      FOOTER_MENU: 'menu/footerMenu',
    }),
  },
};
</script>

<style lang="scss">
.main-block {
  position: relative;

  .logo {
    margin-top: 19px;

    & > span {
      display: block;
      margin-top: 7px;
      color: $gray;
      font-size: 14px;
      line-height: 20px;
    }

    & > a {
      display: block;
      width: 120px;
      height: 24px;
    }
  }

  .contacts {
    color: $gray;
    font-size: 12px;
    line-height: 20px;

    .title {
      display: none;
      color: $black;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
    }

    & > span {
      display: block;
      margin-top: 16px;
      color: $black;
      font-size: 16px;

      &:first-of-type {
        margin-bottom: 4px;
      }
    }
  }

  .socials {
    margin-top: 16px;
  }
}

@include breakpoint("tablet") {
  .main-block {
    display: flex;
    flex-wrap: wrap;

    .container {
      min-width: 0;
      margin: 0;
      padding: 0;
    }

    .lists {
      width: 100%;
    }

    .logo,
    .socials {
      padding-left: 32px;
    }

    .logo {
      width: 50%;
      margin-top: 19px;
    }

    .socials {
      width: 50%;
      transform: translateY(-25px);
    }

    .contacts {
      width: 50%;
      margin-top: 22px;
      font-size: 14px;

      & > span {
        margin-top: 0;
        margin-bottom: 8px;

        &:first-of-type {
          margin-bottom: 8px;
        }

        &:last-of-type {
          margin-top: 24px;
          margin-bottom: 0;
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .main-block {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    max-width: 1288px;
    padding: 56px 32px 0;
    margin: 0 auto;

    .lists {
      display: flex;
      order: 2;
      width: calc(100% / 12 * 5.8);
      margin-right: 24px;
    }

    .title {
      & > span {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .logo,
    .contacts,
    .socials {
      width: auto;
      margin: 0;
      padding: 0;
    }

    .logo {
      order: 1;
      min-width: 184px;
      width: calc((100% / 12) * 2.35);
      margin-right: 72px;
      transform: translateY(-6px);

      & > a {
        width: 184px;
        height: 32px;
      }

      & > span {
        max-width: 240px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .contacts {
      position: relative;
      order: 3;
      width: calc((100% / 12) * 2.85);
      transform: none;

      & > span {
        margin-top: 16px;
        font-size: 20px;
        line-height: 28px;

        &:first-of-type {
          margin-bottom: 4px;
        }

        &:last-of-type {
          margin-top: 16px;
        }
      }

      .title {
        display: block;
      }
    }
    .socials {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 32px;
      transform: translateY(0);
    }
  }
}
</style>
